module.exports = __webpack_public_path__ + "img/hero.17841a52.jpg";